import PageWrapper from '@/components/page-wrapper'
import FeatureBanner from '@/components/feature-banner'
import Styles from './style.module.scss'
import useLang from '@/utils/hooks/use-lang'
import banner from '@/assets/img/contact/banner.jpg'
import Icon from '@/components/icon'
import { Flex } from 'antd'
import ClassName from 'clsx'
import ContactForm from './form'

const _data = {
  en: {
    title: 'Contact Us',
    description: 'Consultation invitation or purchase please contact us',
    list: [
      {
        title: 'Address',
        // content: ['Region: ,OR', 'Detailed address: 13970 SW 72nd Ave, Portland', 'Postal Code: 97223'],
        content: ['780 MONTAGUE EXPRESSWAY,', 'UNIT1101, SAN JOSE, CA 95131'],
      },
      {
        title: 'Contact information',
        content: ['541-91362892', '408-476-9312'],
      },
      {
        title: 'Email',
        content: ['info@carusg.com'],
      },
    ],
  },
  es: {
    title: 'Contáctanos',
    description: 'Para consultas o compras, por favor contáctenos.',
    list: [
      {
        title: 'Dirección',
        // content: ['Region: ,OR', 'Detailed address: 13970 SW 72nd Ave, Portland', 'Postal Code: 97223'],
        content: ['780 MONTAGUE EXPRESSWAY,', 'UNIT1101, SAN JOSE, CA 95131'],
      },
      {
        title: 'Información de contacto',
        content: ['541-91362892', '408-476-9312'],
      },
      {
        title: 'Correo electrónico',
        content: ['info@carusg.com'],
      },
    ],
  },
  cn: {
    title: '联系我们',
    description: '咨询邀约或购买请联系我们',
    list: [
      {
        title: '地址',
        // content: ['地区：,OR', '详细地址：13970 SW 72nd Ave, Portland', '邮编：97223'],
        content: ['780 MONTAGUE EXPRESSWAY,', 'UNIT1101, SAN JOSE, CA 95131'],
      },
      {
        title: '联系方式',
        content: ['541-9136289', '408-476-9312'],
      },
      {
        title: '邮箱',
        content: ['info@carusg.com'],
      },
    ],
  },
}

export default function Detail() {
  const [lang] = useLang()
  const data = _data[lang]

  return (
    <PageWrapper contentClassName={Styles.contact}>
      <FeatureBanner color='#fff' backgroundImage={banner} title={data.title} description={data.description} />
      <Flex vertical className={Styles.content}>
        <Flex align='center' className={ClassName(Styles.contentWrapper, Styles.consultation)}>
          <div></div>
          <Flex vertical align='center' className={Styles.left}>
            <Icon name='paper' />
            <h5>Project Consultation</h5>
            <div className={Styles.description}>
              Please fill out the following form, and our sales representative will contact you as soon as possible
            </div>
          </Flex>
          <ContactForm />
          <div></div>
        </Flex>
        <Flex vertical align='center' className={ClassName(Styles.contentWrapper, Styles.address)}>
          <Icon name='call' />
          <h5>After-sales support</h5>
          <Flex className={Styles.detail}>
            {data?.list.map(d => (
              <Flex vertical className={Styles.item} key={d.title}>
                <div className={Styles.title}>{d.title}</div>
                <Flex vertical justify='center' className={Styles.details}>
                  {d.content?.map(c => (
                    <span key={c}>{c}</span>
                  ))}
                </Flex>
              </Flex>
            ))}
          </Flex>
        </Flex>
      </Flex>
    </PageWrapper>
  )
}
